/** @format */

import template from './gb-purchase-item-amount.html';

export const GbPurchaseItemAmountComponent = {
    template,
    require: {
        gbApp: '^^',
    },
    bindings: {
        purchaseItem: '<',
    },
    controller: class GbPurchaseItemAmountComponent {
        constructor() {
            'ngInject';
        }
    },
};
